import { render, staticRenderFns } from "./FeatureFlagExpandableColumn.vue?vue&type=template&id=d8f64b84&"
import script from "./FeatureFlagExpandableColumn.vue?vue&type=script&lang=js&"
export * from "./FeatureFlagExpandableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports